import { Image } from "primereact/image";
import "primeicons/primeicons.css";
import logo from "../assets/images/CAC-logo.png";
import { Link } from "react-router-dom";
import { MySocialNetworks } from "./Common/MySocialNetworks";

function firstStage() {
  return (
    <div className="flex justify-content-between">
      <div className="align-items-center justify-content-center">
        <div>
          <h4 className="footer-bar-menu mb-3">
            The Diplomatic and Consular Networks Database and Rankings
          </h4>
        </div>
        <div className="mb-2">
          <a
            href="https://arcg.is/1TDPiy1"
            target="_blank"
            rel="noreferrer"
            className="footer-bar-menu"
          >
            GIS platform
          </a>
        </div>
        <div className="mb-2">
          <Link to="ranking-of-country" className="footer-bar-menu">
            Ranking (of country)
          </Link>
        </div>
        <div className="mb-2">
          <Link to="ranking-in-country" className="footer-bar-menu">
            Ranking (in country)
          </Link>
        </div>
        <div className="mb-2">
          <Link to="ranking-in-city" className="footer-bar-menu">
            Ranking (in city)
          </Link>
        </div>
        <div className="mb-2">
          <Link to="daily-database-review" className="footer-bar-menu">
            Daily database review
          </Link>
        </div>
        <div className="mb-2">
          <a
            href="https://doi.org/10.5281/zenodo.14034984"
            target="_blank"
            rel="noreferrer"
            className="footer-bar-menu"
          >
            Methodology
          </a>
        </div>
        <div className="mb-2">
          <Link to="update" className="footer-bar-menu">
            Update
          </Link>
        </div>
      </div>
      <div className="align-items-center justify-content-center">
        <div>
          <h4 className="footer-bar-menu mb-3">Publications</h4>
        </div>
        <div className="mb-2">
          <a
            href="https://magazine.consularaffairs.org"
            target="_blank"
            rel="noreferrer"
            className="footer-bar-menu"
          >
            2026 Ranking Report
          </a>
        </div>
        <div className="mb-2">
          <Link to="the-consular-bibliography" className="footer-bar-menu">
            The Consular Bibliography
          </Link>
        </div>
        <div className="mb-2">
          <Link
            to="the-consular-daily-press-review"
            className="footer-bar-menu"
          >
            The Consular Daily Press Review
          </Link>
        </div>
        <div className="mb-2">
          <div className="footer-bar-menu">The Consular Journal (TBA)</div>
        </div>
        <div className="mb-2">
          <a
            href="https://magazine.consularaffairs.org"
            target="_blank"
            rel="noreferrer"
            className="footer-bar-menu"
          >
            The Consular Magazine
          </a>
        </div>
        <div className="mb-2">
          <Link to="the-consular-newsletter" className="footer-bar-menu">
            The Consular Newsletter
          </Link>
        </div>
        <div className="mb-2">
          <a
            href="https://zenodo.org/communities/theconsularrepository"
            target="_blank"
            rel="noreferrer"
            className="footer-bar-menu"
          >
            The Consular Repository
          </a>
        </div>
        <div className="mb-2">
          <Link to="authors" className="footer-bar-menu">
            Authors
          </Link>
        </div>
        <div className="mb-2">
          <Link to="index" className="footer-bar-menu">
            Index
          </Link>
        </div>
        <div className="mb-2">
          <Link to="submission-guidelines" className="footer-bar-menu">
            Submission guidelines
          </Link>
        </div>
      </div>
      <div className="align-items-center justify-content-center">
        <div>
          <h4 className="footer-bar-menu mb-3">Honorary consuls</h4>
        </div>
        <div className="mb-2">
          <Link to="who-are-honorary-consuls" className="footer-bar-menu">
            Who are honorary consuls?
          </Link>
        </div>
        <div className="mb-2">
          <Link to="honorary-bibliography" className="footer-bar-menu">
            Honorary bibliography
          </Link>
        </div>
        <div className="mb-2">
          <Link to="honorary-corps-directory" className="footer-bar-menu">
            Honorary corps directory
          </Link>
        </div>
        <div className="mb-2">
          <Link to="honorary-jobs" className="footer-bar-menu">
            Honorary jobs
          </Link>
        </div>
        <div className="mb-2">
          <Link to="honorary-news" className="footer-bar-menu">
            Honorary news
          </Link>
        </div>
        <div className="mb-2">
          <Link to="honorary-solutions" className="footer-bar-menu">
            Honorary solutions
          </Link>
        </div>
        <div className="mb-2">
          <Link to="henry-graham-greene" className="footer-bar-menu">
            Henry Graham Greene
          </Link>
        </div>
      </div>
      <div className="align-items-center justify-content-center">
        <div>
          <h4 className="footer-bar-menu mb-3">Resources</h4>
        </div>
        <div className="mb-2">
          <Link to="what-are-consular-affairs" className="footer-bar-menu">
            What are consular affairs?
          </Link>
        </div>
        <div className="mb-2">
          <Link to="what-are-diplomatic-networks" className="footer-bar-menu">
            What are diplomatic networks?
          </Link>
        </div>
        <div className="mb-2">
          <Link to="etymology-and-history" className="footer-bar-menu">
            Etymology and history
          </Link>
        </div>
        <div className="mb-2">
          <Link
            to="1961-and-1963-vienna-conventions"
            className="footer-bar-menu"
          >
            1961 and 1963 Vienna conventions
          </Link>
        </div>
        <div className="mb-2">
          <Link to="consular-jobs-and-internships" className="footer-bar-menu">
            Consular jobs and internships
          </Link>
        </div>
        <div className="mb-2">
          <Link to="did-you-know" className="footer-bar-menu">
            Did you know?
          </Link>
        </div>
        <div className="mb-2">
          <Link to="diplomatic-directory" className="footer-bar-menu">
            Diplomatic directory
          </Link>
        </div>
        <div className="mb-2">
          <Link to="global-consular-forum" className="footer-bar-menu">
            Global Consular Forum
          </Link>
        </div>
        <div className="mb-2">
          <Link to="glossary" className="footer-bar-menu">
            Glossary
          </Link>
        </div>
        <div className="mb-2">
          <Link to="interesting-links" className="footer-bar-menu">
            Interesting links
          </Link>
        </div>
        <div className="mb-2">
          <Link to="international-organizations" className="footer-bar-menu">
            International organizations
          </Link>
        </div>
        <div className="mb-2">
          <Link
            to="migration-laws-regulations-and-policies"
            className="footer-bar-menu"
          >
            Migration laws, regulations, and policies
          </Link>
        </div>
        <div className="mb-2">
          <Link
            to="passports-visas-and-migration-fraud"
            className="footer-bar-menu"
          >
            Passports, visas, and migration fraud
          </Link>
        </div>
      </div>
      <div className="align-items-center justify-content-center">
        <div>
          <h4 className="footer-bar-menu mb-3">The Research Institute</h4>
        </div>
        <div className="mb-2">
          <Link to="about" className="footer-bar-menu">
            About
          </Link>
        </div>
        <div className="mb-2">
          <Link to="research-fellows" className="footer-bar-menu">
            Research fellows
          </Link>
        </div>
        <div className="mb-2">
          <Link to="contributors" className="footer-bar-menu">
            Contributors
          </Link>
        </div>
        <div className="mb-2">
          <Link to="correspondents" className="footer-bar-menu">
            Correspondents
          </Link>
        </div>
        <div className="mb-2">
          <Link to="partners" className="footer-bar-menu">
            Partners
          </Link>
        </div>
        <div className="mb-2">
          <Link to="notice" className="footer-bar-menu">
            Notice
          </Link>
        </div>
        <div className="mb-2">
          <Link to="support-consular-research" className="footer-bar-menu">
            Support consular research
          </Link>
        </div>
        <div className="mb-2">
          <div className="footer-bar-menu">Careers (TBA)</div>
        </div>
        <div className="mb-2">
          <Link to="contact" className="footer-bar-menu">
            Contact
          </Link>
        </div>
      </div>
    </div>
  );
}

function CustomFooter() {
  return (
    <div className="footer-bar">
      <div className="reduce-width">
        {firstStage()}
        <hr style={{ borderTop: "1px solid black", margin: "1rem 0" }} />
        <div className="flex justify-content-between flex-wrap">
          <div className="flex align-items-center justify-content-center">
            <div className="flex justify-content-start flex-wrap">
              <Link to="/" className="flex justify-content-center">
                <Image src={logo} alt="Image" width="80" />
              </Link>
              <div
                className="flex align-items-center justify-content-center"
                style={{
                  maxWidth: "30em",
                  lineHeight: "1.4",
                  color: "black",
                  marginLeft: "1em",
                  textAlign: "justify",
                }}
              >
                The Consular Affairs Center is a nongovernmental, nonpartisan
                research institute for consular affairs and diplomatic networks.
              </div>
            </div>
          </div>
          <div
            className="flex align-items-center justify-content-center"
            style={{ color: "black" }}
          >
            <div className="flex flex-column flex align-items-end">
              <div className="flex align-items-center justify-content-center">
                Get daily news
              </div>
              <div className="flex align-items-center justify-content-center mt-2">
                {MySocialNetworks()}
              </div>
              <div className="flex align-items-center justify-content-center privacy-and-terms">
                <span
                  style={{ textAlign: "center", width: "100%", color: "black" }}
                >
                  or{" "}
                  <Link
                    to="/the-consular-newsletter"
                    style={{
                      textDecoration: "underline",
                      color: "black",
                    }}
                  >
                    subscribe
                  </Link>{" "}
                  to the weekly newsletter
                </span>
              </div>
            </div>
          </div>
        </div>
        <hr style={{ borderTop: "1px solid black", margin: "1rem 0" }} />
        <div className="flex justify-content-between flex-wrap">
          <div
            className="flex align-items-center justify-content-center"
            style={{ color: "black" }}
          >
            © 2026 Consular Affairs Center. All rights reserved.
          </div>
          <div className="flex align-items-center justify-content-center">
            <ul className="footer-menu">
              <li>
                <Link to="about">About</Link>
              </li>
              <li>
                <Link to="privacy-and-terms">Privacy and terms</Link>
              </li>
              <li>
                <Link to="contact">Contact</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomFooter;
